import { useEffect, useMemo, useState } from 'react';

//components
import { howManyYearsLogo } from '../../../assets/images/formAfterSignUp';
import { OptionType } from '../../../types';
import Dropdown from '../../../common/dropdown/Dropdown';
import { useAppDispatch } from '../../../app/hooks';
import { setYearsInBusiness } from '../formAfterSignUpSlice';

// Stylesheets
import styles from '../FormAfterSignUp.module.css';
import jwtDecode from 'jwt-decode';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import ReactGA from 'react-ga4';

export function YearsInBusiness() {
  const options: OptionType[] = [
    { label: '0 year', value: '0 year' },
    { label: '1 year', value: '1 year' },
    { label: '2 years', value: '2 years' },
    { label: '3 years', value: '3 years' },
    { label: '4 years', value: '4 years' },
    { label: '5 years', value: '5 years' },
    { label: '6 years', value: '6 years' },
    { label: '7 years', value: '7 years' },
    { label: '8 years', value: '8 years' },
    { label: '9 years', value: '9 years' },
    { label: '10+ years', value: '10+ years' },
  ];

  const [selectedOption, setSelectedOption] = useState({ value: '', label: '' });
  const signupToken = localStorage.getItem('signup-token');
  const loginToken = localStorage.getItem('login-token');
  const decode: any = jwtDecode(signupToken! ?? loginToken!);
  const { email, firstName, lastName, phoneNumber } = decode;

  const dispatch = useAppDispatch();

  const isDisabled = useMemo(() => (selectedOption.value !== '' ? false : true), [selectedOption]);

  const colorStyle = !isDisabled
    ? styles.proceedBtnbgColorActive
    : styles.proceedBtnbgColorDisabled;

  //   useEffect(() => {
  //     registerNetcoreActivity(
  //       {
  //         emailAddress: email && email,
  //         firstName: firstName && firstName,
  //         lastName: lastName && lastName,
  //         mobileNumber: phoneNumber && phoneNumber,
  //       },
  //       'TBH_SIGN_UP_STEP_6',
  //     );

  //     ReactGA.event({
  //       category: 'Button',
  //       action: 'TBH_SIGN_UP_STEP_6',
  //       label: 'TBH_SIGN_UP_STEP_6',
  //       // value: 1
  //     });
  //   }, []);

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <span>
          <div className='flex justify-center'>
            <img src={howManyYearsLogo} className='h-25 w-25 mb-3' alt='howManyYears.png' />
          </div>
          <div className={styles.headerText}>How many years have you been in business?</div>
          <p className={styles.chooseText}>Choose an option</p>
          <div className='mt-5'></div>
          <div className='flex justify-center '>
            <Dropdown
              className='w-72 sm:w-96'
              options={options}
              placeholder={selectedOption.label}
              setSelectedOption={setSelectedOption}
            />
          </div>
          <div className='mt-5'></div>
          <div className={styles.btnDiv}>
            <button
              className={[styles.proceedBtn, 'w-64 sm:w-80', colorStyle].join(' ')}
              onClick={() => {
                !isDisabled && dispatch(setYearsInBusiness(selectedOption.value));
                registerNetcoreActivity(
                  {
                    emailAddress: email && email,
                    firstName: firstName && firstName,
                    lastName: lastName && lastName,
                    mobileNumber: phoneNumber && phoneNumber,
                  },
                  'TBH_SIGN_UP_USER_YEARS_IN_BUSINESS',
                );

                ReactGA.event({
                  category: 'Button',
                  action: 'TBH_SIGN_UP_USER_YEARS_IN_BUSINESS',
                  label: 'TBH_SIGN_UP_USER_YEARS_IN_BUSINESS',
                  // value: 1
                });
              }}
            >
              Proceed
            </button>
          </div>
        </span>
      </div>
    </div>
  );
}
